import React, { FC } from 'react';

export const Icon: FC<{ icon: string; txt?: string; className?: string }> = ({
    icon,
    txt,
    className,
}) => {
    return (
        <i className={`base-icon icon-${icon} ${className || ''}`}>
            {txt ? <span className="sr-only">{txt}</span> : ''}
        </i>
    );
};
